'use client';

import { useDeviceName } from 'lib/api/myRobot';

import { HUB_URL } from './const';
import { useSignalRHub } from './context/useSignalRHub';

export enum RosbridgeHubEvents {
  ReceiveRosBridgeMessage = 'ReceiveRosBridgeMessage',
  SendRosBridgeMessage = 'SendRosBridgeMessage',
}

/**
 * Hook to use for the Rosbridge hub
 */
export function useRosbridgeHub() {
  const hub = useSignalRHub(HUB_URL.ROSBRIDGE);
  const { deviceName } = useDeviceName();

  async function sendToRosbridge(data: any) {
    return await hub.connection.invoke(RosbridgeHubEvents.SendRosBridgeMessage, data, deviceName);
  }

  const RosbridgeHubClient = {
    sendToRosbridge,
  };

  return { ...hub, RosbridgeHubClient };
}
